import { inPopuper } from "common/usePopuper";
import { ScrollContainer } from "components/Container";
import { useMemo } from "react";
import styled from "styled-components";
import Company from "./Company";
import Footer from "./Footer";
import Header from "./Header";
import Home from "./Home";
import Product from "./Product";
import Verification from "./Verification";

const StickyHeader = styled.div`
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: #fff;
`;
export default inPopuper(function App() {
  // 简单路由切换
  const pathname =
    typeof window !== "undefined" ? window.location.pathname : "/";
  const MainContent = useMemo(() => {
    switch (pathname) {
      case "/about":
        return <Company />;
      case "/product":
        return <Product />;
      case "/verification":
        return <Verification />;
      default:
        return <Home />;
    }
  }, [pathname]);

  return (
    <ScrollContainer id="scroll">
      {/* 顶部导航 */}
      <StickyHeader>
        <Header />
      </StickyHeader>

      {/* 中间区域 */}
      {MainContent}

      {/* 底部信息 */}
      <Footer />
    </ScrollContainer>
  );
});
